export default {
  headers: [
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.drivers', 'driver'],
    ['satellite-tracking/report.start_time', 'startTime'],
    ['satellite-tracking/report.end_time', 'endTime']
  ]
}
